/**
 * Sprachschalter: setzt die Vorlage aus dem Footer (#pc-lang-switch-vorlage, mu-Plugin mp-lang-switch.php)
 * hinter jedes Kadence-Such-Icon (Desktop + Mobil) und steuert das Dropdown (Klick, Escape, Klick außerhalb).
 * Nachfolger von js/pc-lang-switch.js.
 * @module components/language-switch/language-switch
 */

const OPEN = 'pc-lang-switch--offen';

/**
 * Dropdown schließen.
 * @param {HTMLElement} control Schalter
 * @param {boolean} returnFocus Fokus zurück auf den Button
 * @returns {void}
 */
function close(control, returnFocus) {
  const button = control.querySelector('.pc-lang-switch__button');
  control.querySelector('.pc-lang-switch__list').hidden = true;
  control.classList.remove(OPEN);
  button.setAttribute('aria-expanded', 'false');
  if (returnFocus) button.focus();
}

/**
 * Dropdown öffnen und ersten Eintrag fokussieren.
 * @param {HTMLElement} control Schalter
 * @returns {void}
 */
function open(control) {
  const list = control.querySelector('.pc-lang-switch__list');
  list.hidden = false;
  control.classList.add(OPEN);
  control.querySelector('.pc-lang-switch__button').setAttribute('aria-expanded', 'true');
  const first = list.querySelector('a');
  if (first) first.focus();
}

/**
 * Sprachschalter einsetzen und binden.
 * @returns {void}
 */
export function initLanguageSwitch() {
  const template = document.getElementById('pc-lang-switch-vorlage');
  if (!template) return;
  document.querySelectorAll('[data-section="kadence_customizer_header_search"]').forEach((target) => {
    const control = template.content.firstElementChild.cloneNode(true);
    target.parentNode.insertBefore(control, target.nextSibling);
    control.querySelector('.pc-lang-switch__button').addEventListener('click', () => {
      if (control.classList.contains(OPEN)) close(control, false);
      else open(control);
    });
    control.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close(control, true);
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll(`.${OPEN}`).forEach((control) => {
      if (!control.contains(event.target)) close(control, false);
    });
  });
}
